<template>  
  <v-layout column fill-height>    
    <div style="flex:1 0 auto;position:relative;">    
      <v-card class="maincontent logbook mb-1">
        <v-card-title style="flex-direction:column;align-items:stretch;height:100%;overflow:auto">
           <v-layout row wrap style="flex:0 0 auto;" >
              <v-flex class="centercontent" xs1><span style="font-weight:bold">{{$t('Pilot.LogBook.Date')}}</span></v-flex>
              <v-flex class="centercontent" xs1><span style="font-weight:bold">{{$t('Pilot.LogBook.Time')}}</span></v-flex>
              <v-flex class="centercontent" xs2><span style="font-weight:bold">{{$t('Pilot.LogBook.From')}}</span></v-flex>
              <v-flex class="centercontent" xs1><span style="font-weight:bold">{{$t('Pilot.LogBook.Cycle')}}</span></v-flex>
              <v-flex class="centercontent" xs7>                
                <span style="font-weight:bold">{{$t('Pilot.LogBook.Message')}}</span> 
                <v-spacer />
                <v-btn small @click="downloadFile(`/api/logbook/csv/?misid=${mission.misId}`)" color="primary">{{$t('Pilot.LogBook.Download')}}
                  <v-icon small class="pl-2">mdi-download</v-icon>
                </v-btn>               
              </v-flex>              
            </v-layout>                
            <v-layout ref="logbook" row wrap style="flex:1 0;overflow:auto;align-items:flex-start;">                            
              <v-flex xs12 class="inline-block">
                <mission-detail-log-book-row :rowItem="message" v-for="message in logBookItems" :key="message.lbkId" />
              </v-flex>
            </v-layout>
        </v-card-title>
      </v-card>         
    </div>  
    <v-layout v-if="!readonly" row wrap style="flex:0 0 auto;">
      <v-flex xs10 px-2>        
        <v-textarea :rows="2" :label="$t('Pilot.LogBook.Message')"
        @keydown.enter.exact.prevent="sendMessage()"   
        v-model="message" />
      </v-flex>
      <v-flex xs2 pr-3>
        <v-btn color="primary" style="width:100%" @click="sendMessage()">{{$t('Pilot.LogBook.Send')}}</v-btn>    
        <!-- <v-switch hide-details v-model="lbkAlertMission" @change="saveAlertMission" :label="$t('Pilot.LogBook.AlertMission')" v-if="mission.misActifOn"></v-switch> -->
      </v-flex>      
    </v-layout>    
  </v-layout>
</template>
<script lang="ts">
  import Vue from 'vue'
import apiHelpers from '@/utils/api'
import { Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import MissionDetailLogBookRow from '@/components/mission/MissionDetailLogBookRow.vue'
import { AloMission } from '@/models/alo/AloMission'

@Component({
    name: 'MissionDetailLogBook',    
    props:{
      mission: {
        type: AloMission,
        required: true
      },
      readonly: {
        type: Boolean,
        default: false
      }

    },
    components:{MissionDetailLogBookRow}
  })
  export default class MissionDetailLogBook extends Vue {      
    message:string = ""
    mission!: AloMission
    readonly!: boolean
               
    get dataPoolItemsValueByKey() {
      return this.$store.myGetters.dataPoolItemsValueByKey
    }
  

    get lbkAlertMission(){
      return (this.mission?.misLbkAlertStatus==1)?true:false
    }
    set lbkAlertMission(value) {
      this.mission.misLbkAlertStatus = (value)?1:0 
  }  

    get logBookItems(){
      return this.mission.logBookItems
    }

    @Watch('mission')
    onMissionChange(newValue: any){
      if(newValue.misId != null) {                    
        this.$store.myActions.MISSION_LOGBOOK_REQUEST(newValue.misId)
      }
    }

    @Watch('logBookItems')
    onLogBookItemsChanged(newValue: any) {
      if(newValue) {        
        this.$nextTick(() => {
          //@ts-ignore
          this.$refs.logbook.scrollTop = this.$refs.logbook.scrollHeight
        })
      }
    }
     

    created() {      
      if(this.mission.misId != null) {                 
        this.$store.myActions.MISSION_LOGBOOK_REQUEST(this.mission.misId)
      }      
    }   
    
    sendMessage() {      
      this.$store.myActions.MISSION_LOGBOOK_SEND_MESSAGE_REQUEST({ misId:this.mission.misId! ,message:this.message.trim()})      
      this.message = ""
    }

    saveAlertMission() {
      this.$store.myActions.MISSION_LBK_ALERT_SAVE_REQUEST({misId:this.mission.misId!,alertStatus:(this.lbkAlertMission)?1:0})
    }

    downloadFile(url:string){
      apiHelpers.downloadFile(url)
    }    

  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table {
  width:100%;
  display: table;  
}

.logbook {
  font-size: 12px;
}


tbody {	
	height:25em; /* 5 times the equivalent of a text "size". */
	overflow-y:scroll;
}
</style>
